var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal-category-instructions",
        "header-bg-variant": "inbox",
        "header-text-variant": "white",
        scrollable: ""
      },
      on: { show: _vm.onShow, hidden: _vm.onHidden },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function() {
            return [
              _c("span", { staticStyle: { display: "block" } }, [
                _vm._v("Add Instructions")
              ]),
              _vm._v(" "),
              _vm.primaryCategory
                ? _c("span", [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.primaryCategory) + " "),
                      _vm.secondaryCategory
                        ? _c(
                            "span",
                            [
                              _c("b-icon", {
                                attrs: { icon: "chevron-right" }
                              }),
                              _vm._v(" " + _vm._s(_vm.secondaryCategory))
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ])
                : _vm._e()
            ]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "light" },
                  on: {
                    click: function($event) {
                      return _vm.$bvModal.hide("modal-category-instructions")
                    }
                  }
                },
                [_vm._v("\n      Cancel\n    ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "inbox", disabled: _vm.saving },
                  on: { click: _vm.save }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.saving ? "Saving..." : "Save") +
                      "\n    "
                  )
                ]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "category-instructions-editor" },
        [
          _c("vue-editor", {
            attrs: {
              "editor-toolbar": _vm.toolbar,
              placeholder: "Enter instructions for this category..."
            },
            model: {
              value: _vm.instructionsContent,
              callback: function($$v) {
                _vm.instructionsContent = $$v
              },
              expression: "instructionsContent"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }